// Эти экшены используются в других фронтах (core, 3D). dispatch из этих фронтов не подойдет для стора utils
// Добавил обертку с локальным dispatch'ем
import { compose } from '@reduxjs/toolkit'

import { getStore } from '../store'
import {
  addCopyVariogramDataNotification as addCopyVariogramDataNotificationAction,
  addDeletedToTrashElementAddErrorNotification as addDeletedToTrashElementAddErrorNotificationAction,
  addDeleteElementEventNotification as addDeleteElementEventNotificationAction,
  addDeleteErrorNotification as addDeleteErrorNotificationAction,
  addEmptyPointsetCalculationNotification as addEmptyPointsetCalculationNotificationAction,
  addFileUploadErrorNotification as addFileUploadErrorNotificationAction,
  addGltfLoadErrorNotification as addGltfLoadErrorNotificationAction,
  addMlErrorNotification as addMlErrorNotificationAction,
  addMlStatusNotification as addMlStatusNotificationAction,
  addOrchCalculationErrorNotification as addOrchCalculationErrorNotificationAction,
  addPickerProgressNotification as addPickerProgressNotificationAction,
  addPolygonNotification as addPolygonNotificationAction,
  addProjectStateChangedNotification as addProjectStateChangedNotificationAction,
  addPublishedElementNotification as addPublishedElementNotificationAction,
  addSimpleNotification as addSimpleNotificationAction,
  addSurvey2dFileUploadErrorNotification as addSurvey2dFileUploadErrorNotificationAction,
  addSwapErrorNotification as addSwapErrorNotificationAction,
  addVspAppliedNotification as addVspAppliedNotificationAction,
  addVSPErrorNotification as addVSPErrorNotificationAction,
} from './notificationsActions'

const dispatch = getStore().dispatch

export const addMlStatusNotification = compose(dispatch, addMlStatusNotificationAction)

export const addDeleteErrorNotification = compose(dispatch, addDeleteErrorNotificationAction)

export const addDeleteElementEventNotification = compose(
  dispatch,
  addDeleteElementEventNotificationAction,
)

export const addSwapErrorNotification = compose(dispatch, addSwapErrorNotificationAction)

export const addPolygonNotification = compose(dispatch, addPolygonNotificationAction)

export const addMlErrorNotification = compose(dispatch, addMlErrorNotificationAction)

export const addFileUploadErrorNotification = compose(
  dispatch,
  addFileUploadErrorNotificationAction,
)

export const addVSPErrorNotification = compose(dispatch, addVSPErrorNotificationAction)

export const addVspAppliedNotification = compose(dispatch, addVspAppliedNotificationAction)

export const addSurvey2dFileUploadErrorNotification = compose(
  dispatch,
  addSurvey2dFileUploadErrorNotificationAction,
)

export const addPublishedElementNotification = compose(
  dispatch,
  addPublishedElementNotificationAction,
)

export const addOrchCalculationErrorNotification = compose(
  dispatch,
  addOrchCalculationErrorNotificationAction,
)

export const addEmptyPointsetCalculationNotification = compose(
  dispatch,
  addEmptyPointsetCalculationNotificationAction,
)

export const addSimpleNotification = compose(dispatch, addSimpleNotificationAction)

export const addPickerProgressNotification = compose(dispatch, addPickerProgressNotificationAction)

export const addProjectStateChangedNotification = compose(
  dispatch,
  addProjectStateChangedNotificationAction,
)

export const addGltfLoadErrorNotification = compose(dispatch, addGltfLoadErrorNotificationAction)

export const addCopyVariogramDataNotification = compose(
  dispatch,
  addCopyVariogramDataNotificationAction,
)

export const addDeletedToTrashElementAddErrorNotification = compose(
  dispatch,
  addDeletedToTrashElementAddErrorNotificationAction,
)
